import { ReactNode } from 'react';

import { ViewBy } from '../../../../types/snapshot.types';
import { SnapshotViewByAll } from './snapshot-all';
import { SnapshotViewByStakeholder } from './snapshot-stakeholder';
import { SnapshotViewByType } from './snapshot-type';
import { SnapshotViewByProps } from './snapshot-view-by.types';

export const snapshotViewBy: Record<'all' | ViewBy, (props: SnapshotViewByProps) => ReactNode> = {
  [ViewBy.STAKEHOLDERS]: (props) => <SnapshotViewByStakeholder {...props} />,
  [ViewBy.TYPE]: (props) => <SnapshotViewByType {...props} />,
  all: (props) => <SnapshotViewByAll {...props} />,
};
